import _default from './Tab';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Tab/index.js
// module id = 2756
// module chunks = 1